var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography, useTheme, } from "@mui/material";
import Grid from "@mui/material/Grid";
import LeadDetailApi from "../../../../infrastructure/api/pages/lead-detail-api";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Notepad, Pencil, Plus, Trash, CheckCircle, Circle, } from "@phosphor-icons/react";
import "../ChatSection/ChatSection.scss";
import useAsyncEffect from "use-async-effect";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import LeadTaskModal from "../../../pages/lead-details/LeadTaskModal";
dayjs.extend(utc);
import { toast } from "react-toastify";
import "./TaskList.scss";
import UsersApi from "../../../../infrastructure/api/pages/users-api";
const TaskList = ({ refresh }) => {
    const defaultData = {
        id: undefined,
        leadId: "",
        description: "",
        responsiblePersonId: "",
        responsiblePersonName: "",
        responsiblePersonPhoto: "",
        deadline: new Date(),
        createdOn: new Date(),
    };
    const urlParams = new URLSearchParams(globalThis.location.search);
    const leadId = urlParams.get("id");
    const theme = useTheme();
    const { t: translate } = useTranslation();
    const [tasks, setTasks] = useState([]);
    const [data, setData] = useState(defaultData);
    const [refereshGrid, setRefereshGrid] = useState(false);
    const [leadTaskId, setLeadTaskId] = useState("");
    const [users, setUsers] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [activeTab, setActiveTab] = useState(0);
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [taskToDelete, setTaskToDelete] = useState();
    const [selectedTaskIds, setSelectedTaskIds] = useState([]);
    const [statusUpdating, setStatusUpdating] = useState(false);
    const handleOpenModal = () => {
        setShowPopup(true);
    };
    const showPopupOnNewUser = () => {
        setShowPopup(true);
        setLeadTaskId("");
    };
    const getData = (filter) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const result = yield UsersApi.getAllAdminUsers(filter);
            if (Array.isArray(result.data)) {
                setUsers(result.data);
            }
        }
        catch (error) {
            console.error("Error while fetching adminusers:", error);
        }
    });
    useEffect(() => {
        getData(false);
    }, []);
    const handleEditTask = (id) => __awaiter(void 0, void 0, void 0, function* () {
        if (id) {
            LeadDetailApi.getLeadTaskById(id)
                .then((response) => {
                if (response.status === 200 && response.data != null) {
                    setLeadTaskId(id);
                    setData(response.data);
                    handleOpenModal();
                }
            });
        }
    });
    useEffect(() => {
        const user = users.find((user) => user.id === data.responsiblePersonId);
        data.responsiblePersonName = (user === null || user === void 0 ? void 0 : user.firstName) + " " + (user === null || user === void 0 ? void 0 : user.lastName);
    }, [data]);
    const handleDeleteClick = (id) => {
        setTaskToDelete(id);
        setDeleteConfirmOpen(true);
    };
    const handleDeleteConfirm = () => {
        if (taskToDelete) {
            LeadDetailApi.deleteLeadTask(taskToDelete)
                .then((response) => {
                if (response.status === 200 && response.data != null) {
                    toast.success(translate("LeadTaskDeleted"));
                    setRefereshGrid((prev) => !prev);
                }
            })
                .catch((error) => {
                console.error("Error deleting task:", error);
            });
        }
        setDeleteConfirmOpen(false);
        setTaskToDelete(undefined);
    };
    const handleDeleteCancel = () => {
        setDeleteConfirmOpen(false);
        setTaskToDelete(undefined);
    };
    const handleTaskSelectionToggle = (id) => {
        if (!id)
            return;
        setSelectedTaskIds((prev) => prev.includes(id) ? prev.filter((taskId) => taskId !== id) : [...prev, id]);
    };
    const handleBulkStatusUpdate = () => {
        if (statusUpdating) {
            return;
        }
        if (selectedTaskIds.length === 0) {
            toast.warning(translate("Please select atleast one task"));
            return;
        }
        const wasCompletingTasks = activeTab === 0;
        setStatusUpdating(true);
        LeadDetailApi.isCompleted(selectedTaskIds)
            .then((response) => {
            if (response.status === 200 && response.data != null) {
                toast.success(translate(wasCompletingTasks
                    ? "Task Completed Successfully"
                    : "Task marked as in-progress"));
                setRefereshGrid((prev) => !prev);
                setSelectedTaskIds([]);
                // Auto-open create task modal after marking tasks as completed
                if (wasCompletingTasks) {
                    setLeadTaskId("");
                    setData(defaultData);
                    setShowPopup(true);
                }
            }
        })
            .catch(() => {
            toast.error(translate("InvalidLeadTask"));
        })
            .finally(() => setStatusUpdating(false));
    };
    useAsyncEffect(() => __awaiter(void 0, void 0, void 0, function* () {
        if (leadId) {
            LeadDetailApi.getLeadTaskByLeadId(leadId).then((response) => {
                if (Array.isArray(response.data)) {
                    setTasks(response.data);
                }
            });
        }
    }), [leadId, refresh, refereshGrid]);
    const inProgressTasks = tasks.filter((t) => !t.isCompleted);
    const completedTasks = tasks.filter((t) => t.isCompleted);
    const displayedTasks = activeTab === 0 ? inProgressTasks : completedTasks;
    useEffect(() => {
        setSelectedTaskIds([]);
    }, [activeTab]);
    useEffect(() => {
        const visibleIds = new Set(displayedTasks.map((task) => task.id));
        setSelectedTaskIds((prev) => {
            const filtered = prev.filter((id) => visibleIds.has(id));
            return filtered.length === prev.length ? prev : filtered;
        });
    }, [tasks, activeTab]);
    return (_jsxs(_Fragment, { children: [_jsxs(Grid, { container: true, className: "tasklist", sx: {
                    justifyContent: "space-between",
                    bgcolor: theme.palette.common.white,
                    borderRadius: "24px",
                    padding: "var(--2, 16px) var(--4, 32px)",
                    gap: "var(--2, 16px)",
                }, size: {
                    lg: 12,
                    xs: 12
                }, children: [_jsxs(Box, { sx: {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            width: "100%",
                        }, children: [_jsx(Typography, { className: "heading", children: translate("Lead Tasks") }), _jsx(Button, { type: "submit", variant: "contained", size: "small", onClick: showPopupOnNewUser, children: _jsx(Plus, { size: 20 }) })] }), _jsxs(Box, { sx: {
                            display: "flex",
                            gap: 1,
                            width: "100%",
                            justifyContent: "space-between",
                            alignItems: "center",
                            flexWrap: "wrap",
                        }, children: [_jsxs(Box, { sx: { display: "flex", gap: 1 }, children: [_jsxs(Button, { variant: activeTab === 0 ? "contained" : "outlined", size: "small", onClick: () => setActiveTab(0), children: [translate("In-Progress"), " (", inProgressTasks.length, ")"] }), _jsxs(Button, { variant: activeTab === 1 ? "contained" : "outlined", size: "small", onClick: () => setActiveTab(1), children: [translate("Completed"), " (", completedTasks.length, ")"] })] }), _jsxs(Button, { variant: "contained", size: "small", disabled: selectedTaskIds.length === 0 || statusUpdating, onClick: handleBulkStatusUpdate, children: [activeTab === 0
                                        ? translate("Mark as Completed")
                                        : translate("Mark as In-Progress"), statusUpdating ? (_jsx(CircularProgress, { size: 20, color: "inherit", sx: { ml: 1 } })) : null] })] }), displayedTasks.length === 0 ? (_jsx(Grid, { size: {
                            lg: 12,
                            xs: 12
                        }, sx: {
                            display: "flex",
                            justifyContent: "space-between"
                        }, children: _jsx(Typography, { sx: { width: "85%" }, children: activeTab === 0
                                ? translate("No in-progress tasks for this lead")
                                : translate("No completed tasks for this lead") }) })) : (displayedTasks.map((d) => {
                        var _a;
                        return (_jsxs(Box, { className: "rightmessage", sx: { display: "block", width: "100%" }, children: [_jsxs(Box, { sx: {
                                        mb: 1,
                                        display: "flex",
                                        gap: 0.5,
                                        alignItems: "center"
                                    }, children: [_jsx(Box, { sx: {
                                                display: "flex",
                                                alignItems: "center",
                                                cursor: "pointer",
                                                flexShrink: 0,
                                            }, onClick: () => handleTaskSelectionToggle(d.id), children: d.id && selectedTaskIds.includes(d.id) ? (_jsx(CheckCircle, { size: 22, weight: "fill", color: theme.palette.primary.main })) : (_jsx(Circle, { size: 22, color: theme.palette.text.disabled })) }), _jsxs(Box, { sx: {
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1,
                                                flex: "1 1 auto",
                                                minWidth: 0,
                                            }, children: [_jsx(Notepad, { size: 20, style: { flexShrink: 0 } }), _jsx(Typography, { className: "nametext", noWrap: true, children: d.responsiblePersonName })] }), d.isCompleted ? (_jsxs(Box, { sx: {
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "flex-end",
                                                gap: 0.5,
                                                flexShrink: 0,
                                            }, children: [_jsx(Box, { sx: {
                                                        px: 1,
                                                        py: 0.25,
                                                        borderRadius: "999px",
                                                        bgcolor: theme.palette.success.light,
                                                    }, children: _jsx(Typography, { className: "datetext", sx: { fontWeight: 500 }, children: `${translate("Completed")}: ${dayjs
                                                            .utc((_a = d.completedDate) !== null && _a !== void 0 ? _a : d.createdOn)
                                                            .local()
                                                            .format("DD-MM-YYYY")}` }) }), _jsx(Box, { sx: {
                                                        px: 1,
                                                        py: 0.25,
                                                        borderRadius: "999px",
                                                        bgcolor: theme.palette.grey[100],
                                                    }, children: _jsx(Typography, { className: "datetext", children: `${translate("Deadline")}: ${dayjs
                                                            .utc(d.deadline)
                                                            .local()
                                                            .format("DD-MM-YYYY")}` }) })] })) : (_jsx(Typography, { className: "datetext", sx: { flexShrink: 0 }, children: `${translate("Deadline")}: ${dayjs
                                                .utc(d.deadline)
                                                .local()
                                                .format("DD-MM-YYYY")}` }))] }), _jsxs(Box, { sx: { display: "flex", gap: 1, alignItems: "center" }, children: [_jsx(Typography, { className: "nametext", sx: {
                                                flex: "1 1 auto",
                                                textDecoration: d.isCompleted ? "line-through" : "none",
                                                opacity: d.isCompleted ? 0.6 : 1,
                                            }, children: d.description }), !d.isCompleted && (_jsxs(Box, { sx: {
                                                display: "flex",
                                                gap: 0.5,
                                                alignItems: "center",
                                                flexShrink: 0,
                                            }, children: [_jsx(Pencil, { size: 20, style: { cursor: "pointer" }, onClick: () => handleEditTask(d.id) }), _jsx(Trash, { size: 20, style: { cursor: "pointer" }, onClick: () => handleDeleteClick(d.id) })] }))] })] }, d.id));
                    }))] }), _jsxs(Dialog, { open: deleteConfirmOpen, onClose: handleDeleteCancel, maxWidth: "xs", fullWidth: true, children: [_jsx(DialogTitle, { children: translate("Delete Task") }), _jsx(DialogContent, { children: _jsx(DialogContentText, { children: translate("Are you sure you want to delete this task? This action cannot be undone.") }) }), _jsxs(DialogActions, { children: [_jsx(Button, { onClick: handleDeleteCancel, variant: "outlined", size: "small", children: translate("Cancel") }), _jsx(Button, { onClick: handleDeleteConfirm, variant: "contained", size: "small", sx: {
                                    bgcolor: theme.palette.primary.main,
                                    color: theme.palette.primary.contrastText,
                                    "&:hover": {
                                        bgcolor: theme.palette.primary.dark,
                                    },
                                }, children: translate("Delete") })] })] }), _jsx(LeadTaskModal, { leadTaskId: leadTaskId, data: data, title: leadTaskId ? translate("UpdateLeadTask") : translate("AddLeadTask"), buttonText: leadTaskId ? translate("UpdateLeadTask") : translate("AddLeadTask"), showPopup: showPopup, translate: translate, onClosePopup: () => {
                    setShowPopup(false);
                    setLeadTaskId("");
                    setData(defaultData);
                }, onSave: () => setRefereshGrid(!refereshGrid) })] }));
};
export default TaskList;
